import React from 'react';
import Select from 'react-select'
import ColumnNew from '../components/ColumnNew';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import Header from '../menu/header2'




const services= () => (
<div>
<Header></Header>
  <section style={{paddingTop:'5em',backgroundColor:'#e5dfca'}}>
    <div style={{backgroundColor:'#e5dfca'}}>
      <div className='container'>
        <div className='row m-10-hor'>
          <div className='col-12'>
            <h1 className='text-center' style={{color:'black'}}>Our Services</h1>
            <br></br>
            <h2 style={{color:'black'}}>Smart Contract development, Defi apps, NFT Collections, Content Creation, 2D/3D Motion/Animation, Branding and gaming.</h2>
            <hr style={{borderBottom: '10px solid black'}}></hr>
            <br></br>
            <h2 style={{color:'black'}}>
We bridge brands, artists, and companies with the metaverse to help bring their ideas to life.
<br></br>
<br></br>
We'd love to work with you. Contact us.
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>



  <Footer />
</div>

);
export default services;